const adminRoles = ['admin', 'owner'];

/**
 * Returns true if given role should be considered an 'admin'
 */
const isAdminRole = (role: string | undefined) =>
  Boolean(role && adminRoles.includes(role));

export default isAdminRole;
